import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import {
  ContentNameInfoStyled,
  InNetworkPillStyled,
  SearchResultsContentCardStyled,
} from '../ChoosePCPDrawerStyled';

interface SearchResultsProps {
  providerItem: any;
  index: string;
}

export const SearchResultsContent = ({
  providerItem,
  index,
}: SearchResultsProps) => {
  const { t } = useTranslation('enrollment.searchResultPCPDrawer');
  const isMobile = window.innerWidth < 744;
  return (
    <SearchResultsContentCardStyled
      id={`provider-info-${index}`}
      data-testid={`provider-info-${index}`}
    >
      <ContentNameInfoStyled className="d-flex justify-content-md-between">
        <div>
          <Typography variant="body1" fontWeight={600}>
            {providerItem?.name}
          </Typography>
        </div>
        {!isMobile && providerItem?.in_network && (
          <InNetworkPillStyled variant="overline">
            {t('dental.inNetworkLabel')}
          </InNetworkPillStyled>
        )}
      </ContentNameInfoStyled>
      <div className="d-flex justify-content-md-between">
        <div>
          <Typography variant="body2" gutterBottom>
            {providerItem?.office_name}
          </Typography>
          <Typography variant="body2" gutterBottom>
            {providerItem?.street_address}
          </Typography>
          <Typography variant="body2" gutterBottom>
            {providerItem?.city_state_zip}
          </Typography>
          <Typography variant="body2" className="mb-3">
            {providerItem?.phone_number}
          </Typography>
        </div>
        {!isMobile && (
          <Typography variant="body2" fontWeight={600}>
            {providerItem?.specialty}
          </Typography>
        )}
      </div>
      {providerItem?.accepting_new === 'Y' && (
        <Typography variant="body2" className="mb-3">
          {t('dental.acceptingNewPatients')}
        </Typography>
      )}
      {isMobile && providerItem?.in_network && (
        <div className="mb-5">
          <div className="mb-2">
            {' '}
            <InNetworkPillStyled variant="overline">
              {t('dental.inNetworkLabel')}
            </InNetworkPillStyled>
          </div>

          <Typography variant="body2" fontWeight={600}>
            {providerItem?.specialty}
          </Typography>
        </div>
      )}
    </SearchResultsContentCardStyled>
  );
};
